<template>
<div class="container">
    <h2>DK Errors</h2>
    <div class="text-start">
        <div class="form-group class mb-3">
            <input type="text" v-model="searchTerm" placeholder="Search for an error..." class="form-control">
        </div>
        <div class="list-group w-auto mb-4" v-for="(value, key) in filteredErrors" :key="key">
            <a href="#" class="list-group-item list-group-item-action d-flex gap-3 py-3" aria-current="true">
                <!-- <div v-if="value.status == 1">
                    <img src="../assets/good.svg" alt="Your SVG Image"/>
                </div>
                <div v-else>
                    <img src="../assets/bad.svg" alt="Your SVG Image"/>
                </div> -->

                <div class="d-flex gap-2 w-100 justify-content-between">
                    <div>
                        <h6 class="mb-0 text-capitalize fw-semibold">{{ value.Constant_name }}</h6>
                        <p class="mb-0 opacity-75">Error Value: {{ value.Value }}</p>
                        <!-- <p class="mb-0 opacity-75">Error Name: {{ value.Constant_name }}</p> -->
                        <p class="mb-0 opacity-75">Description: {{ value.Description }}</p>
                    </div>
                    <!-- <small class="opacity-50 text-nowrap">Active: {{ value.implemented ? "Active" : "Inactive" }}</small> -->
                </div>
            </a>
        </div>
    </div>
</div>
</template>

<script>
import errorData from "../../utils/dkctrlErrors.json";
import dkLibNotResultCode from "../../utils/dkLibNotResultCode.json";
export default {
    name: "dkerrors",
    data() {
        return {
            errors: errorData.concat(dkLibNotResultCode),
            searchTerm: ""
        }
    },
    computed: {
        filteredErrors() {
            return this.errors.filter((error) => {
                return error.Value.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
                    error.Constant_name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
                       error.Description.toLowerCase().includes(this.searchTerm.toLowerCase())
            });
        }
    }
}
</script>

<style>

</style>
